import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'

const MajrLogo = ({ sx }: { sx?: SxProps }) => (
  <Box sx={sx}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 279 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M99.898 45.2428C101.696 45.2428 105.292 45.2037 106.699 44.422L104.119 57.3197C100.445 60.3682 96.2632 61.8925 91.5731 61.8925C80.9424 61.8925 75.627 57.4369 75.627 48.5258C75.627 46.9625 75.7833 45.2819 76.096 43.484L78.5583 29.0621C78.7928 27.6551 78.91 26.2481 78.91 24.8411C78.91 21.0891 76.8386 19.213 72.6957 19.213C68.631 19.213 65.4261 20.8155 63.0811 24.0203L56.2805 61.8925H36.3479L42.3277 29.0621C42.5622 27.6551 42.6794 26.2481 42.6794 24.8411C42.6794 21.0891 40.5689 19.213 36.3479 19.213C32.9867 19.213 30.0945 20.5028 27.6713 23.0823L19.9327 61.8925H0L11.475 2.21163H30.0007L28.3748 10.8882C33.0648 5.10382 39.0055 2.21163 46.1969 2.21163C56.3587 2.21163 62.1431 5.57283 63.5501 12.2952C68.2402 5.57283 74.4936 2.21163 82.3103 2.21163C90.2052 2.21163 95.3252 3.97039 97.6702 7.48793C99.2335 9.91112 100.015 12.5688 100.015 15.461C100.015 18.3532 99.8198 20.9718 99.429 23.3168L96.4977 40.7873C96.4195 41.2563 96.3804 41.6862 96.3804 42.077C96.3804 44.1875 97.553 45.2428 99.898 45.2428Z"
        fill="url(#paint0_linear_655_635)"
      />
      <path
        d="M167.435 42.077C167.435 44.1094 168.451 45.1255 170.483 45.1255C172.594 45.1255 176.815 44.0312 178.222 43.2495L175.173 57.2024C171.421 60.2509 167.2 61.7752 162.51 61.7752C153.912 61.7752 149.143 58.6485 148.205 52.3951C144.297 58.6485 138.552 61.7752 130.97 61.7752C118.15 61.7752 111.74 56.2644 111.74 45.2428C111.74 43.3668 111.936 41.2953 112.327 39.0285L114.789 25.3101C116.04 18.275 118.893 12.6861 123.348 8.54319C127.882 4.32215 133.745 2.21163 140.936 2.21163C148.205 2.21163 153.13 3.89223 155.71 7.25342L157.234 2.21163H175.056L167.552 40.67C167.474 41.139 167.435 41.608 167.435 42.077ZM132.728 36.449C132.572 37.1525 132.494 38.1296 132.494 39.3802C132.494 40.6309 133.08 41.8816 134.253 43.1323C135.425 44.3048 137.379 44.891 140.115 44.891C142.929 44.891 145.352 43.7967 147.385 41.608L150.902 21.9098C150.042 19.9556 148.01 18.9785 144.805 18.9785C138.786 18.9785 135.269 21.8707 134.253 27.6551L132.728 36.449Z"
        fill="url(#paint1_linear_655_635)"
      />
      <path
        d="M212.628 2.01672C213.661 2.01672 214.756 1.79785 215.915 1.36011C217.068 0.924265 217.399 0.559845 218.087 5.03187e-06L204.458 69.8511C203.442 75.4792 201.253 79.9347 197.892 83.2177C194.609 86.5789 190.924 87.6733 183.967 87.6733C181.857 87.6733 179.902 87.2824 178.104 86.5008C176.228 85.7973 174.9 85.0546 174.118 84.273L172.945 83.1005L177.049 69.8511C177.987 70.6328 179.472 71.0236 181.505 71.0236C184.241 71.0236 185.882 69.5384 186.429 66.5681L198.154 1.36011L199.293 0.891109C200.89 0.297036 202.611 0 204.458 0C205.554 0 206.931 0.343937 208.59 1.03181C210.28 1.68842 211.626 2.01672 212.628 2.01672Z"
        fill="url(#paint2_linear_655_635)"
      />
      <path
        d="M278.357 15.8128C278.357 18.4705 277.888 21.05 276.95 23.5513C276.09 26.0527 275.23 27.8896 274.37 29.0621L273.08 30.7037H255.375C257.33 28.9058 258.307 26.678 258.307 24.0203C258.307 22.6133 257.838 21.4799 256.9 20.6201C256.04 19.682 254.828 19.213 253.265 19.213C250.607 19.213 247.715 20.6591 245.761 23.3168L239.192 61.421H220.432L230.401 2.21163H249.745L248.106 11.5917C252.561 5.26016 256.782 2.21163 263.114 2.21163C268.195 2.21163 271.986 3.42322 274.487 5.84641C277.067 8.2696 278.357 11.5917 278.357 15.8128Z"
        fill="url(#paint3_linear_655_635)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_655_635"
          x1="139.001"
          y1="-0.000232085"
          x2="139.001"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8900B9" />
          <stop offset="1" stopColor="#432485" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_655_635"
          x1="139.001"
          y1="-0.000232085"
          x2="139.001"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8900B9" />
          <stop offset="1" stopColor="#432485" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_655_635"
          x1="139.001"
          y1="-0.000232085"
          x2="139.001"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8900B9" />
          <stop offset="1" stopColor="#432485" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_655_635"
          x1="139.001"
          y1="-0.000232085"
          x2="139.001"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8900B9" />
          <stop offset="1" stopColor="#432485" />
        </linearGradient>
      </defs>
    </svg>
  </Box>
)

export default MajrLogo
